module.exports = (parcelRequire.load("bXNV7")).then(() => parcelRequire('dA1d2'));